<template>
	<q-page padding>
		<div class="row gutter-sm">
			<div class="col-12">
				<div class="row">
					<div class="col-xs-12 col-sm-12">
						<div class="col-12">
								<q-input v-model="titles" ref="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch"/>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="row">
						<div class="col-xs-12 col-sm-12">
							<div class="col-12">
									<q-input v-model="link" ref="link" :float-label="$t('link')" :error="$v.link.$error" @input="$v.link.$touch" />
							</div>
						</div>
				</div>
			</div>
			
			<div class="col-xs-12">
				<q-select
					v-model="use_iframe"
					ref="use_iframe"
					:options="use_iframes"
					:float-label="$t('Apresentado em um Iframe')"
					:error="$v.use_iframe.$error"
					@input="$v.use_iframe.$touch"
				/>
			</div>
			<div class="col-xs-12">
				<q-select
					v-model="in_merged_menu"
					ref="in_merged_menu"
					:options="in_merged_menus"
					:float-label="$t('Está com link mesclado')"
					:error="$v.in_merged_menu.$error"
					@input="$v.in_merged_menu.$touch"
				/>
			</div>
			<div class="col-xs-12">
				<q-select
					v-model="use_token"
					ref="use_token"
					:options="use_tokens"
					:float-label="$t('Utiliza Token')"
					:error="$v.use_token.$error"
					@input="$v.use_token.$touch"
				/>
			</div>
			<div class="row gutter-sm q-mt-xs">

				<div class="col-xs-12 col-sm-12">
					<p class="caption">{{ $t('areas') }}</p>
					<q-checkbox
						class="q-mb-sm"
						v-model="all_areas"
						:val="true"
						:label="$t('select_all_areas')"
						@input="checkAllAreas()"
					/>
					<q-select
						filter
						autofocus-filter
						v-model="area"
						ref="area"
						:options="areas"
						:error="$v.area.$error"
						multiple
						chips
					/>
				</div>

				<div class="col-xs-12 col-sm-12">
					<p class="caption">{{ $t('profiles') }}</p>
					<div class="row gutter-sm">
						<div class="col-xs-12 col-sm-12">
							<q-checkbox
								v-model="all_profiles"
								:val="true"
								:label="$t('all')"
								@input="checkAll()"
							/>
						</div>

						<div
							class="col-xs-12 col-sm-4"
							v-for="(item, index) in profiles"
							:key="index"
							:class="getErrorClass($v.profile.$error)"
						>
							<q-checkbox
								keep-color
								v-model="profile"
								ref="profile"
								:val="item.value"
								:label="item.label"
								:color="getErrorColor($v.profile.$error)"
							/>
						</div>
					</div>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-select
						v-model="user_group"
						ref="user_group"
						:options="user_groups"
						:float-label="$t('groups')"
						multiple
						chips
					/>
				</div>
			</div>

			<div class="col-12">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_wild_cards' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'

export default {
	i18nOptions: { namespaces: ['common', 'admin'] },

	components: {
		uploader: Uploader,
	},

	data() {
		return {
			all_areas: false,
			link: '',
			titles: [],
			all_profiles: false,
			profile: [],
			area: [],
			user_group: [],
			status: 1,
			statuses: [
				{ label: this.$t('published'), value: 1 },
				{ label: this.$t('unpublished'), value: 2 },
			],
			in_merged_menu: null,
			in_merged_menus: [
				{ label: this.$t('true'), value: true },
				{ label: this.$t('false'), value: false },
			],
			use_token: null,
			use_tokens: [
				{ label: this.$t('true'), value: true },
				{ label: this.$t('false'), value: false },
			],
			use_iframe: null,
			use_iframes: [
				{ label: this.$t('true'), value: true },
				{ label: this.$t('false'), value: false },
			],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/country_areas',
			countries: 'registration_lists/countries',
			user_clients: 'common/user_clients',
			laguages: 'params/languages',
			profiles: 'registration_lists/profiles',
			user_groups: 'registration_lists/group_users',
			languages: 'params/languages',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/clients/wildcard_page/${this.$route.params.id}/`, this.getHeader)
				.then((response) => {
					this.area = response.data.areas
					this.profile = response.data.profiles
					this.status = response.data.status
					this.titles = response.data.title
					this.link = response.data.link
					this.use_iframe = response.data.use_iframe
					this.use_token = response.data.use_token
					this.user_group = response.data.user_groups
					this.in_merged_menu = response.data.in_merged_menu
					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
				})
		},

		saveData() {
			
			this.$v.$touch()
			if (!this.$v.$error) {
				this.$q.loading.show()
        
				let data = {
					title: this.titles,
					image: this.image,
					status: this.status,
					link: this.link,
					areas: this.area,
					profiles: this.profile,
					use_iframe: this.use_iframe,
					use_token: this.use_token,
					user_groups: this.user_group,
					in_merged_menu: this.in_merged_menu,
				}

				if (this.$route.params.id == 0) {
					this.$axios
						.post(`/clients/wildcard_page/`, data, this.getHeader)
						.then(() => {
							this.$q.notify({
								message: this.$t('wildcard_add_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})

							this.$router.push({ name: 'admin_wild_cards' })
						})
						.catch((e) => {
							this.$q.notify({
								message: this.$t('wildcard_add_error'),
								type: 'negative',
								icon: 'fal fa-ban',
							})

							console.log(e)
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				} else {
					this.$axios
						.put(`/clients/wildcard_page/${this.$route.params.id}/`, data, this.getHeader)
						.then(() => {
							this.$q.notify({
								message: this.$t('wildcard_edit_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})

							this.$router.push({ name: 'admin_wild_cards' })
						})
						.catch((e) => {
							this.$q.notify({
								message: this.$t('wildcard_add_error'),
								type: 'negative',
								icon: 'fal fa-ban',
							})

							console.log(e)
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				}
			}
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		objTitle() {
			this.titles = ''
		},

		checkAllAreas() {
			if (this.all_areas) {
				this.area = this.areas.map((e) => e.value)
			} else this.area = []
		},

		checkAll() {
			if (this.all_profiles) {
				this.profile = this.profiles.map((e) => e.value)
			} else this.profile = []
		},

		getErrorColor(state) {
			if (state) return 'negative'
			else return ''
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		clearData() {
			this.area = []
			this.profile = []
			this.user_group = []
		},
	},

	created() {

		if (this.$route.params.id != 0) this.fetchData()
		else this.objTitle()
	},

	validations() {
		return {
			area: {
				requiredIf: () => {
					if (this.profile.length > 0 && this.area.length > 0) {
						return true
					} else if (this.user_group.length > 0) {
						return true
					} else {
						return false
					}
				},
			},
			profile: {
				requiredIf: () => {
					if (this.profile.length > 0 && this.area.length > 0) {
						return true
					} else if (this.user_group.length > 0) {
						return true
					} else {
						return false
					}
				},
			},
			title: {
				requiredIf: requiredIf(() => {
					if (
						this.titles === ""
					) {
						return true
					} else {
						return false
					}
				}),
			},
			link: {
				requiredIf: requiredIf(() => {
					if (
						this.link === ""
					) {
						return true
					} else {
						return false
					}
				}),
			},
			use_iframe: {
				requiredIf: requiredIf(() => {
					if (
						this.use_iframe === undefined || this.use_iframe === null
					) {
						return true
					} else {
						return false
					}
				}),
			},
			use_token: {
				requiredIf: requiredIf(() => {

					if (
						this.use_token === null || this.use_token === undefined
					) {
						return true
					} else {
						return false
					}
				}),
			},
			in_merged_menu: {
				requiredIf: requiredIf(() => {

					if (
						this.in_merged_menu === null || this.in_merged_menu === undefined
					) {
						return true
					} else {
						return false
					}
				}),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>
